export default "__VITE_ASSET__CvhA6WEy__"